console.log("report js");
// --- mobile menu trigger
const menuTrigger = ()=>{
    const menuBtn = document.querySelector(".menuHeader");
    const menuDropdown = document.querySelector(".menuDropdown");
    console.log(menuBtn);
    menuBtn.addEventListener("click", ()=>{
        console.log('click');
        menuBtn.classList.toggle("active");
        menuDropdown.classList.toggle("active");
    });
};
// --- filter trigger
const filterTrigger = ()=>{
    const filters = document.querySelectorAll("filterBtn");
};
try {
    // (document.querySelector("")) ? wechatCodePopup():null;
    menuTrigger();
} catch (error) {
    console.log(error);
}

//# sourceMappingURL=index.f0fed017.js.map
